import { isRTLLocale } from '@wix/cashier-common/dist/src/utils/isRTLLocale';
import { createCurrencyFormatterWithDefaults } from '@wix/l10n';
import { t } from '../../../../utils/i18n';
import { pendingShippingOption } from '../consts';
import { ShippingMethod } from '../../../../types/Shipping';

const getTranslatedPendingShippingOption = (): google.payments.api.SelectionOption => {
  return {
    id: pendingShippingOption.id,
    label: t(pendingShippingOption.label),
    description: '', // required - Google have bug with types
  };
};

interface GetShippingOptionsParams {
  shippingMethods?: ShippingMethod[];
  currencyCode: string;
  locale: string;
  isRequired: boolean;
}

export const getShippingOptions = ({
  shippingMethods = [],
  currencyCode,
  locale,
  isRequired,
}: GetShippingOptionsParams): google.payments.api.SelectionOption[] => {
  /**
   * Parameters of merchant provided shipping option. If
   * paymentDataRequest#shippingOptionRequired is set then the request must
   * also provide ShippingOptionParameters with at least one option.
   * Developer can set a shipping option labeled "PENDING" if there's
   * nothing to show at initial request time.
   */
  if (isRequired) {
    if (shippingMethods.length === 0) {
      return [getTranslatedPendingShippingOption()];
    }
  }

  return shippingMethods.map((option) => {
    const label = getShippingOptionLabel({
      label: option.label,
      amount: option.amount,
      currencyCode,
      locale,
    });
    return {
      id: option.identifier,
      label,
      description: option.detail || '', // required - Google have bug with types
    };
  });
};

interface GetShippingOptionLabelParams {
  label: string;
  amount: string;
  currencyCode: string;
  locale: string;
}

export const getShippingOptionLabel = ({ label, amount, currencyCode, locale }: GetShippingOptionLabelParams) => {
  const createCurrencyFormatter = createCurrencyFormatterWithDefaults({
    language: locale,
  });
  const formatCurrency = createCurrencyFormatter();

  const price = formatCurrency({ value: amount, currency: currencyCode });

  if (isRTLLocale(locale)) {
    return `${price} - ${label}`;
  }

  return `${label} - ${price}`;
};
